module.exports = __webpack_public_path__ + "img/Water-Jet.6386081b.jpg";